import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  width: 432px;
  height: 283px;
  background-color: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};

  @media (max-width: 1440px) {
    width: 420px;
  }

  @media (max-width: 1024px) {
    width: 420px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const CardHeader = styled(Box)`
  width: 100%;
  height: 85px;
  flex-shrink: 0;
  padding: ${theme.spacing.small}px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
`

export const CardHeaderIcon = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 53px;
  height: 53px;
  padding: ${theme.spacing.xSmall}px;
  border-top: 1px solid ${theme.colors.borderMedium};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background-color: ${theme.colors.devicesRowHoverBg};
  color: ${theme.colors.dropdownLabel};

  html[data-theme='light'] & {
    border-top-color: transparent;
    background-color: ${theme.colors.cardFillTertiary};
    color: #6b6b76;

    /* The report icons bake a stroke on the <svg> or its paths; a CSS stroke property beats both. */
    svg,
    svg path {
      stroke: #6b6b76;
    }
  }
`

export const CardHeaderTitle = styled(Typography)`
  display: block;
  max-width: 259px;
  font-size: ${theme.typography.fontSize.header};
  font-weight: ${theme.typography.fontWeight.extraThick};
  color: ${theme.colors.menuItemText};
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CardHeaderSubTitle = styled(Typography)`
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  color: ${theme.colors.devicesSecondaryText};
`

export const CardHeaderSubTitleLastGenerated = styled('span')`
  color: ${theme.colors.menuItemText};
  font-weight: ${theme.typography.fontWeight.bold};
`

export const CardBody = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  padding: ${theme.spacing.small}px;
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.devicesSecondaryText};
  line-height: 20px;
  letter-spacing: 0.1px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
`

export const CardDatesRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.small}px;
  flex-wrap: wrap;
  margin-top: 12px;
`

export const CardDateText = styled(Typography)`
  color: ${theme.colors.devicesSecondaryText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 22px;
`

export const CardDateBold = styled('span')`
  color: ${theme.colors.menuItemText};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
`

export const DescriptionText = styled(Box)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CardFooter = styled(Box)`
  width: 100%;
  padding: 0 ${theme.spacing.small}px ${theme.spacing.small}px ${theme.spacing.small}px;
`

